module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-wood-rovere-naturale.3dc381e4.jpg";